import filter from "lodash/filter";

const fieldToFriendlyName = {
  name: "Campaign Name",
  brandName: "Brand Name",
  productName: "Product or Service Name",
  goal: "What do you want to accomplish?",
  website: "Website",
  productDescription: "Product Description",
  totalBudget: "What's your total budget?",
  productExchangeInstructions: "Instructions for podcasters to redeem product online",
  script: "Talking points or script",
  contentMediaFileUUID: "Upload MP3",
};

/* validateCampaign returns [bool, Array[strings]]

  returns [true, []] if the form is complete otherwise [false, [list of fields that are missing]]
 */
export const validateCampaign = campaign => {
  if (!campaign) return [false, []];

  const nonEmptyStrings = [
    "name",
    "brandName",
    "productName",
    "productDescription",
    "website",
    "goal",
    "totalBudget",
  ];
  const emptyFields = filter(nonEmptyStrings, field => !campaign[field]);

  if (campaign.productExchangeType === "instructions") {
    if ((campaign?.productExchangeInstructions?.length ?? 0) <= 0) {
      emptyFields.push("productExchangeInstructions");
    }
  }

  if (campaign.style === "hostRead") {
    if (!campaign.script || campaign.script === "<p><br></p>") {
      emptyFields.push("script");
    }
  } else if (!campaign.contentMediaFileUUID) {
    emptyFields.push("contentMediaFileUUID");
  }

  return [emptyFields.length === 0, emptyFields.map(field => fieldToFriendlyName[field])];
};
